import { contractService } from "../../../../configs/constants";
import { message } from "antd";
import axios from "../../../../utils/axiosInceptor";
import { GET_LEASEFORMS, ADD_UNITS_VISIBLE, SET_LEAD_ID, GET_CURRENT_PAGE } from "./constants";
import { dateByformat } from "../../../../utils/dateHelper";

type Params = {
  limit: number;
  page?: number;
  value?: string;
  field?: string;
  leaseStatus?: string | null;
  exportData?: boolean;
  setExportData?: (v: boolean) => void;
  setIsLoading?: (v: boolean) => void;
  totalCount?: number;

  startDateFrom?: string | null;
  startDateTo?: string | null;
  vactingDateFrom?: string | null;
  vactingDateTo?: string | null;
  endDateFrom?: string | null;
  endDateTo?: string | null;

  currentLease?: boolean;
  leaseColumns?: any[];
  usagesType?: string | null;
  propertyId?: string | null;
  unitId?: string | null;
};

export const getLeaseForms =
  ({
    limit,
    page = 1,
    value = "",
    field,
    leaseStatus = null,
    exportData = false,
    setExportData,
    setIsLoading,
    totalCount,
    startDateFrom,
    startDateTo,
    vactingDateFrom,
    vactingDateTo,
    endDateFrom,
    endDateTo,
    currentLease = false,
    leaseColumns = [],
    usagesType = null,
    propertyId,
    unitId,
  }: Params) =>
  async (dispatch: any) => {
    try {
      const formatDate = (date?: string | null) => (date ? dateByformat(date, "YYYY-MM-DD") : "");

      const params = new URLSearchParams();

      // Base filters
      params.append("unitstatus", "occupied");
      params.append("limit", String(limit));
      params.append("page", String(page));
      params.append("searchby", field || "");
      params.append("text", value || "");
      params.append("currentLease", String(currentLease));
      if (usagesType && usagesType !== "") {
        params.append("usagesType", usagesType);
      }

      // ✅ NEW FILTERS
      if (propertyId) {
        params.append("propertyId", String(propertyId));
      }

      if (unitId) {
        params.append("unitId", String(unitId));
      }
      // Date filters
      const filters = {
        leaseTermStartDateFrom: formatDate(startDateFrom),
        leaseTermStartDateTo: formatDate(startDateTo),
        leaseTermEndDateFrom: formatDate(endDateFrom),
        leaseTermEndDateTo: formatDate(endDateTo),
        vacatingDateFrom: formatDate(vactingDateFrom),
        vacatingDateTo: formatDate(vactingDateTo),
      };

      Object.entries(filters).forEach(([key, val]) => {
        if (val) params.append(key, val);
      });

      const baseUrl = `${contractService}/booking/findAllForLease?${params.toString()}`;

      // Export logic
      let url = baseUrl;

      if (exportData) {
        const checkedColumns = leaseColumns
          ?.filter((col) => col.checked && col.headerName !== "Actions")
          .map((col) => col.headerName)
          .join(", ");

        url += `&exportData=true&columns=${checkedColumns}&totalCount=${totalCount || 0}`;
      }

      if (leaseStatus) {
        url += `&leaseStatus=${leaseStatus}`;
      }

      const {
        data: { result },
      } = await axios.get(url);

      if (result) {
        dispatch({
          type: GET_LEASEFORMS,
          data: result,
        });

        if (exportData) {
          message.success("Export in progress. You will receive the exported file in your email in few minutes");
          setExportData?.(false);
        }
      }
    } catch (error: any) {
      message.error(error?.response?.data?.message || "Something went wrong");
    } finally {
      setIsLoading?.(false);
    }
  };

export const visiblePopup = () => (dispatch) => {
  dispatch({
    type: ADD_UNITS_VISIBLE,
    data: true,
  });
};

export const getLeadID = (leadID) => (dispatch) => {
  dispatch({
    type: SET_LEAD_ID,
    data: leadID,
  });
};

export const getCurrentPage = (currentPage) => (dispatch) => {
  dispatch({
    type: GET_CURRENT_PAGE,
    data: currentPage,
  });
};
